export const environment = {
  production: false,
  apiBaseUrl: 'https://qapdhapi.icodex.in/api'
  // apiBaseUrl: 'https://localhost:7174/api'
};
